import React from 'react';
import Modal from 'components/commons/modal/Modal';
import { Link } from 'react-router-dom';
import Button from 'components/commons/button/Button';

const getTargetGoalLink = (targetGoalId: string): string => {
  return `/target/${targetGoalId}`;
};

type TargetRelatedConfirmModalProps = {
  targetGoalId?: string; // 目標が渡されたなら、目標確認リンクを表示
  execute: {
    execute: () => void;
    executeButtonMessage: string;
  }; // FIXME: confirmが必要な重要な行為という意味でexecute
  cancel: () => void; // あくまでcancelとcloseは別の概念では？
  title: string;
  content: JSX.Element;
  // 以下モーダル関連
  isShow: boolean;
  close: () => void;
};

const TargetRelatedConfirmModal: React.FC<TargetRelatedConfirmModalProps> = props => {
  return (
    <Modal isShow={props.isShow} close={props.close}>
      <div className="ui-effect-fade-in-300 modal-advice">
        <div className="flex pt-3 px-3 justify-end modal-header">
          <div className="flex-grow flex justify-center items-center">
            <div className="modal-header-title">{props.title}</div>
          </div>
          <button>
            <i
              className="icon-close text-2xl text-gray-500 text-center cursor-pointer"
              onClick={props.close}></i>
          </button>
        </div>
        <div className="modal-advice-body">
          <div className="modal-primary-note">{props.content}</div>
          <div className="btn-vertical-col">
            <Button fluid primary onClick={props.execute.execute}>
              {props.execute.executeButtonMessage}
            </Button>
            {props.targetGoalId && (
              <Button
                fluid
                outline
                link
                onClick={(): void => {
                  return;
                }}>
                <Link
                  to={
                    props.targetGoalId
                      ? getTargetGoalLink(props.targetGoalId)
                      : ''
                  }>
                  目標を確認する
                </Link>
              </Button>
            )}
            <Button fluid text onClick={props.cancel}>
              キャンセル
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TargetRelatedConfirmModal;
